import axios from "axios";
import Cookie from "js-cookie";
import { Graph3DNode, Graph3DLink } from "./types";

import { QueryFunctionContext } from "@tanstack/react-query";

const axiosInstance = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "http://127.0.0.1:8000/api/v1/"
      : process.env.REACT_APP_BACKEND_TARGET_DOMAIN,
  withCredentials: true,
});
export const uploadWork = ({ text }: any) =>
  axiosInstance
    .post(
      `/order_requests/`,
      { text },
      {
        headers: {
          "X-CSRFToken": Cookie.get("csrftoken") || "",
        },
      }
    )
    .then((response) => response.data);

export const uploadFile = (form_data: any) =>
  axiosInstance
    .post(`/files/`, form_data, {
      headers: {
        "X-CSRFToken": Cookie.get("csrftoken") || "",
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);

export const createSize = ({ form_data }: any) => {
  return axiosInstance
    .post(`sizes/`, form_data, {
      headers: {
        "X-CSRFToken": Cookie.get("csrftoken") || "",
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
};
export const updateSize = ({ form_data }: any) => {
  return axiosInstance
    .put(`sizes/`, form_data, {
      headers: {
        "X-CSRFToken": Cookie.get("csrftoken") || "",
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
};

export async function getSizes({}) {
  const response = await axiosInstance.get(`sizes/`);
  return response.data;
}
export async function getSizeSingle({ queryKey }: any) {
  const [param, sizeId] = queryKey;
  const response = await axiosInstance.get(`sizes/${sizeId}`);
  return response.data;
}
export async function getWorks({}) {
  const response = await axiosInstance.get(`works/`);
  return response.data;
}
export async function getWorkSingle({ queryKey }: any) {
  const [param, workId] = queryKey;
  const response = await axiosInstance.get(`works/${workId}`);
  return response.data;
}
export async function getTests({}) {
  const response = await axiosInstance.get(`tests/`);
  return response.data;
}
export async function getArticles({}) {
  const response = await axiosInstance.get(`articles/`);
  return response.data;
}
export async function getEducations({}) {
  const response = await axiosInstance.get(`educations/`);
  return response.data;
}
export async function getEducationSingle({ queryKey }: any) {
  const [_, educationId] = queryKey;
  const response = await axiosInstance.get(`educations/${educationId}`);
  return response.data;
}
export async function getArticleSingle({ queryKey }: any) {
  const [_, articleId] = queryKey;
  const response = await axiosInstance.get(`articles/${articleId}`);
  return response.data;
}

axiosInstance.get(`sizes/`).then((response) => response.data);
// FILE UPLOAD
export const getUploadURL = ({ file }: any) =>
  axiosInstance
    .post(`sizes/get-url`, null, {
      headers: {
        "X-CSRFToken": Cookie.get("csrftoken") || "",
      },
    })
    .then((response) => ({ file: file, data: response.data }));
export const getUploadURLMultiple = ({ files }: any) =>
  axiosInstance
    .post(
      `sizes/get-url-multi`,
      { count: files.length },
      {
        headers: {
          "X-CSRFToken": Cookie.get("csrftoken") || "",
        },
      }
    )
    .then((response) => ({ files: files, data: response.data }));

export interface IUploadImageVariables {
  file: Blob;
  uploadURL: string;
}
export const uploadImage = ({ file, uploadURL }: IUploadImageVariables) => {
  const form = new FormData();
  form.append("file", file);
  return axios
    .post(uploadURL, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => response.data);
};

export const uploadImages = ({ files, uploadURLs }: any) => {
  let results = [];
  for (let i = 0; i < files.length; i++) {
    let result = uploadImage({ file: files[i], uploadURL: uploadURLs[i] });
    results.push(result);
  }
  return results;
};
export const customUploadImage = ({ file, uploadURL, fileName }: any) => {
  const form = new FormData();
  form.append("file", file);
  return axios
    .post(uploadURL, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      console.log(
        `${fileName}, https://imagedelivery.net/OsJkSw9Sjt8i9jgP9HvzGw/${response.data.result.id}/public`
      );
      return response.data;
    });
};

// 그래프 관련

export const getGraphData = async (): Promise<{
  nodes: Graph3DNode[];
  links: Graph3DLink[];
}> => {
  const [nodesRes, linksRes] = await Promise.all([
    axiosInstance.get("/archi_law_model/nodes/"),
    axiosInstance.get("/archi_law_model/cons/"),
  ]);

  return {
    nodes: nodesRes.data,
    links: linksRes.data,
  };
};

export const getSubgraph = async (nodeId: string) => {
  const res = await axiosInstance.get(`/archi_law_model/subgraph/${nodeId}/`);
  return res.data;
};

export const getLawToLocalConnections = async (nodeId: string) => {
  const res = await axiosInstance.get(
    `/archi_law_model/local-connections/${nodeId}/`
  );
  return res.data;
};
export const getLots = async (pnu: string) => {
  const res = await axiosInstance.get(`/props/lots/${pnu}/`);
  return res.data;
};

export const getNodeExplanation = async (nodeId: string): Promise<string> => {
  const res = await axiosInstance.get(`/archi_law_model/chat-gpt/${nodeId}/`);
  return res.data.explanation;
};

export const getRealEstateData = async () => {
  const res = await axiosInstance.get(`/props/sales/`);
  return res.data;
};

export const updateRealEstateLike = async (
  id: string | number,
  is_like: boolean
) => {
  const res = await axiosInstance.patch(`/props/sales/${id}/like/`, {
    is_like,
  });
  return res.data;
};

export const RefreshAllSales = async () => {
  const res = await axiosInstance.post(`/props/sales/refresh/`, null, {
    headers: {
      "X-CSRFToken": Cookie.get("csrftoken") || "",
    },
  });
  return res.data;
};
